module.exports = __webpack_public_path__ + "static/media/Sopra-Steria-e1495534571983.f8d397fd.png";